<template>
	<div class="no-content">
		<div class="no-content--icon">
			<Icon
				icon-name="switches"
				size="xxl"
			/>
		</div>
		<div class="no-content--message">
			{{ transUcfirst('one.tag_center_all_sections_disabled.info') }}
		</div>
		<div class="no-content--button">
			<button
				class="button button--icon"
				@click="onEnableClick"
			>
				<Icon
					icon-name="settings-gear"
					size="sm"
				/>
				<span>{{ transUcfirst('one.tag_center_all_sections_disabled.activate') }}</span>
			</button>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name:    'NoEnabledSections',
	methods: {
		...mapActions({
			setTaggingToolSettingsOpen: 'app/setTaggingToolSettingsOpen',
		}),
		onEnableClick() {
			this.setTaggingToolSettingsOpen(true);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import "@videotools/sass/_fonts.scss";

.no-content {
	display: flex;
	flex-direction: column;
	height: 100%;
	align-items: center;
	color: var(--color-grey-500);
	padding-top: 180px;

	&--icon {
		margin-bottom: 16px;
	}

	&--message {
		@include text-md-2;
		margin-bottom: 32px;
	}

	&--button {
		button {
			@include text-sm-2;
			line-height: initial;
			padding: 6px 12px;
			color: var(--color-soft-white);
			background-color: var(--color-green-petrol);
			border-color: var(--color-green-petrol);
		}
	}
}
</style>
